(() => {
  // ---- Réglages ----
  const MIN_CHARS   = 7;
  const DEBOUNCE_MS = 800;
  const COUNTRY     = 'fr';
  const LIMIT_TO_ADDRESSES = true;

  // Détection widget
  const ZAPIET_SELECTOR = '#storePickupApp, [data-zapiet], .zapiet, #zapiet-checkout, #zapiet-widget';

  // Debounce par instance
  const timers = new WeakMap();

  function patchAutocompleteService() {
    const g = window.google;
    if (!g?.maps?.places?.AutocompleteService) return false;

    const P = g.maps.places;
    if (P.__ycPatchedService) return true;

    const original = P.AutocompleteService.prototype.getPlacePredictions;

    P.AutocompleteService.prototype.getPlacePredictions = function(req, cb) {
      try {
        const input = (req?.input || '').trim();

        // Min chars
        if (input.length < MIN_CHARS) {
          cb && cb([], 'ZERO_RESULTS');
          return;
        }

        // Pays + type
        req = req || {};
        req.componentRestrictions = req.componentRestrictions || {};
        req.componentRestrictions.country = COUNTRY;
        if (LIMIT_TO_ADDRESSES) req.types = ['address'];

        // Debounce par instance
        const key = this;
        clearTimeout(timers.get(key));
        const t = setTimeout(() => {
          timers.delete(key);
          original.call(key, req, cb);
        }, DEBOUNCE_MS);
        timers.set(key, t);
      } catch (e) {
        return original.call(this, req, cb);
      }
    };

    P.__ycPatchedService = true;
    return true;
  }

  // Certains widgets utilisent le constructeur "Autocomplete" (champ attaché à un input)
  function patchAutocompleteConstructor() {
    const g = window.google;
    if (!g?.maps?.places?.Autocomplete) return false;

    const P = g.maps.places;
    if (P.__ycPatchedCtor) return true;

    const OrigCtor = P.Autocomplete;

    P.Autocomplete = function(input, opts) {
      // Force des options plus strictes
      opts = opts || {};
      opts.componentRestrictions = opts.componentRestrictions || { country: COUNTRY };
      if (LIMIT_TO_ADDRESSES) opts.types = ['address'];

      const instance = new OrigCtor(input, opts);

      // Debounce input event pour limiter les frappes
      let timeout;
      const handler = (e) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          // L'autocomplete natif relancera sa prédiction après le délai
        }, DEBOUNCE_MS);
      };

      // Sécurise l'attache de l'écouteur
      try {
        input.addEventListener('input', handler, true);
      } catch {}

      return instance;
    };

    // Conserver le prototype/props
    P.Autocomplete.prototype = OrigCtor.prototype;
    Object.setPrototypeOf(P.Autocomplete, OrigCtor);

    P.__ycPatchedCtor = true;
    return true;
  }

  function canPatch() {
    // Si le widget est dans un iframe externe, on ne pourra pas patcher
    const iframe = document.querySelector('iframe[src*="zapiet"]');
    if (iframe && iframe.contentWindow && iframe.contentWindow !== window) {
      // Cross-origin => pas de patch possible depuis le thème
      return !iframe; // false => on évite les boucles
    }
    return true;
  }

  // Routine de (re)patch régulière
  function repatchLoop() {
    if (!canPatch()) return; // probable iframe => rien à faire côté thème

    const haveZapiet = !!document.querySelector(ZAPIET_SELECTOR);
    const haveGoogle = !!(window.google && google.maps && google.maps.places);

    if (haveZapiet && haveGoogle) {
      const sOk = patchAutocompleteService();
      const cOk = patchAutocompleteConstructor();
      // Rien à loguer en prod, mais tu peux décommenter pour debug :
      // if (sOk || cOk) console.info('[Zapiet Guard] patched', { sOk, cOk });
    }
    setTimeout(repatchLoop, 500); // re-essaye toutes les 500 ms (faible coût)
  }

  // Surveille les mutations (re-render du widget)
  const mo = new MutationObserver(() => { /* le repatchLoop s’en charge */ });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Démarre
  repatchLoop();
})();
